import { render, staticRenderFns } from "./index.vue?vue&type=template&id=273f6389&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=273f6389&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273f6389",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VersionSelectBox: require('/var/jenkins_home/workspace/b.speedtest.cn/components/versionSelectBox.vue').default})
